import { actions } from '@ehi/global-marketing-interface';
import { getReservationPickupLocation, getReservationReturnLocation } from 'selectors/reservationSelectors';
import { getInitialPickupLocation, getInitialReturnLocation } from 'selectors/progressBarSelectors';

import RESERVATIONS from 'constants/reservations';

const { location } = RESERVATIONS.RESFLOW_PATHS_CONFIG;

/**
 * Restores the GMI initiate UI state for locations
 * with data from the GMA initiate request.
 * commiting the changes.
 * @returns Redux thunk
 */
export const restoreGMIUIToInitiateState = () => (dispatch, getState) => {
  const state = getState();
  const gmaPickupLocation = getInitialPickupLocation(state);
  const gmaReturnLocation = getInitialReturnLocation(state);
  const gboPickupLocation = getReservationPickupLocation(state);
  const gboReturnLocation = getReservationReturnLocation(state);

  const isGMALocationIsDifferentFromGBO =
    (gmaPickupLocation?.name !== gboPickupLocation?.name && gmaPickupLocation?.id !== gboPickupLocation?.id) ||
    (gmaReturnLocation?.name !== gboReturnLocation?.name && gmaReturnLocation?.id !== gboReturnLocation?.id);

  const isOnLocationPage = location.includes(window.location.hash.substring(1)) && isGMALocationIsDifferentFromGBO;

  return dispatch(
    actions.reservations.hydrateUiReservationsState({
      initiateFromGma: isOnLocationPage,
    })
  );
};
